import React, { useState } from "react";
import { Row, Col, Select, Button, Space } from "antd";
import { ListToolBar, ProCard } from "@ant-design/pro-components";
import LineChart from "./LineChart";
import BarChart from "./BarChart";
import PieChart from "./PieChart";
import DonutChart from "./DonutChart";
import { useTranslation } from "react-i18next";
import PieChartDetailsModal from "../View/PieChart";
import DonutChartDetailsModal from "../View/DonutChart";

import styles from "./index.module.scss";

const filterOptions = [
  { value: "option", label: "option1" },
  { value: "option2", label: "option2" },
  { value: "option3", label: "option3" },
];

interface ChartCardProps {
  title: string;
  extra?: React.ReactNode;
  children: React.ReactNode;
}

function ChartCard({ title, extra, children }: ChartCardProps) {
  const { t } = useTranslation();

  return (
    <ProCard className={styles.chartCard}>
      {/* The toolbar ProTable puts above a table, in its two-line form: the
          title on the first line, the controls on the second, which is how
          these cards were laid out by hand before. Padding, the gap between
          controls and the title's type now come from the component. */}
      <ListToolBar
        multipleLine
        title={title}
        // Space, not a div of our own: the toolbar already lays the filter line
        // out as a flex row, so all that was ever ours here was the 8px between
        // the controls — which is Space's default.
        filter={
          <Space>
            <Select
              className={styles.select}
              placeholder={t("placeholder.select")}
              options={filterOptions}
            />
            {extra}
          </Space>
        }
      />

      {children}
    </ProCard>
  );
}

export default function ChartsSection() {
  const { t } = useTranslation();
  const [openPieModal, setOpenPieModal] = useState(false);
  const [openDonutModal, setOpenDonutModal] = useState(false);

  return (
    <>
      <Row gutter={16}>
        <Col span={12}>
          <ChartCard title={t("pages.dashboard.analytics.normalisedLineChart")}>
            <LineChart />
          </ChartCard>
        </Col>

        <Col span={12}>
          <ChartCard
            title={t("pages.dashboard.analytics.shrinkableAxisBarChart")}
          >
            <BarChart />
          </ChartCard>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <ChartCard
            title={t("pages.dashboard.analytics.pieChartSpider")}
            extra={
              <Button onClick={() => setOpenPieModal(true)}>
                {t("common.viewDetails")}
              </Button>
            }
          >
            <PieChart />
          </ChartCard>
        </Col>

        <Col span={12}>
          <ChartCard
            title={t("pages.dashboard.analytics.basicRingDiagram")}
            extra={
              <Button onClick={() => setOpenDonutModal(true)}>
                {t("common.viewDetails")}
              </Button>
            }
          >
            <DonutChart />
          </ChartCard>
        </Col>
      </Row>

      <PieChartDetailsModal
        open={openPieModal}
        onClose={() => setOpenPieModal(false)}
      />

      <DonutChartDetailsModal
        open={openDonutModal}
        onClose={() => setOpenDonutModal(false)}
      />
    </>
  );
}
